import clsx from '@vangst/lib/clsx'
import Image from 'next/image'
import { useRouter } from 'next/router'

function StateRequirementsHeaderMap() {
  const { query } = useRouter()
  const state = query?.slug

  return (
    <div className="mood-grey">
      <div className="contain-xc flow-y-sm py-8 md:py-16">
        <div className="relative flex h-[35vw] w-full justify-center">
          <Image
            alt="Map of the United States"
            className="size-auto object-contain"
            src="https://assets.vangst.com/states/states-map-dec-2024.svg"
            fill
          />
        </div>
        <div
          className={clsx(state != null ? 'prose' : 'grid-two-up', 'mood-grey')}
        >
          <span className="mt-4 block text-sm italic">
            * This map and corresponding state information is not updated in
            real time. For up-to-the-minute information on requirements to work
            in cannabis, visit the governing body links provided on each state
            page.
          </span>
          <div className="flex justify-center gap-4 sm:grid sm:grid-cols-2 sm:gap-8">
            <Stat
              className="sm:justify-self-end"
              color="text-green"
              number="24"
              title="States & Districts"
              copy="Adult Use"
            />
            <Stat
              className="sm:justify-self-end"
              color="text-blue"
              number="18"
              title="States & Districts"
              copy="Medical"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

type StatType = {
  className?: string
  color: string
  copy: string
  number: string
  title: string
}

function Stat({ color, className, title, number, copy }: StatType) {
  return (
    <dl className={clsx('flex w-40 flex-col gap-2 text-center', className)}>
      <dt className="order-2 border-b border-grey-lightest pb-2">{title}</dt>
      <dd className={clsx(color, 'order-first heading-xl')}>{number}</dd>
      <dd className="order-last">{copy}</dd>
    </dl>
  )
}

export default StateRequirementsHeaderMap
